export enum EnumTipoMedicamento {
    Generico,
    Referencia,
    Similar,
    Patente,
    Outros
}